import { render } from "./DialogBase.vue?vue&type=template&id=6c02b0c0"
import script from "./DialogBase.vue?vue&type=script&lang=js"
export * from "./DialogBase.vue?vue&type=script&lang=js"

import "./DialogBase.vue?vue&type=style&index=0&id=6c02b0c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/dialog/DialogBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c02b0c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c02b0c0', __exports__)) {
    api.reload('6c02b0c0', __exports__)
  }
  
  module.hot.accept("./DialogBase.vue?vue&type=template&id=6c02b0c0", () => {
    api.rerender('6c02b0c0', render)
  })

}


export default __exports__